import React, { Component } from 'react';
import styled from 'styled-components';
import { Link, withRouter } from 'react-router-dom';
import Colors from '../Styles/Colors';
import Fonts from '../Styles/Fonts';

const Container = styled.div`
    width: 100%;
    background: ${Colors.goldDark};
`;
const BackButton = styled(Link)`
    position: absolute;
    left: 19px;
    top: 22px;

    .icon-svg {
        .icon-svg-fill {
            fill: ${Colors.black};
        }
    }
`;
const TitleText = styled.h1`
    ${Fonts.decotura.medium};
    font-size: 29px;
    line-height: 25px;
    color: ${Colors.black};
    text-transform: uppercase;
`;

class NavigationHeader extends Component {
    componentDidMount = () => {};

    getBackUrl = () => {
        const routePaths = this.props.location.pathname.split("/").filter((route) => { return route !== ""});
        routePaths.pop();

        if (routePaths.length) {
            return '/' + routePaths.join('/');
        } else {
            return '/';
        }
    }

    render() {
        const backToUrl = this.getBackUrl();
        return (
            <Container>
                <BackButton to={backToUrl}>
                    <svg className="icon-svg" width="8" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M2.877 7.5l4.852 5.628c.424.492.343 1.205-.187 1.606-.55.416-1.364.334-1.803-.175L.271 8.215a1.079 1.079 0 0 1 0-1.43L5.74.44c.44-.51 1.254-.59 1.803-.175.53.4.61 1.114.187 1.606L2.877 7.5z" className="icon-svg-fill" fillRule="nonzero"/></svg>
                </BackButton>
                <TitleText>{ this.getTitleText() }</TitleText>
            </Container>
        );
    }

    getTitleText = () => {
        let titleText = "";
        if (this.props.title && this.props.title.length > 0) {
            titleText += this.props.title;
        }
        if (this.props.subtitle && this.props.subtitle.length > 0) {
            if (titleText.length > 0) {
                titleText += ": ";
            }
            titleText += this.props.subtitle;
        }

        return titleText;
    }
}

export default withRouter(NavigationHeader);
